import styled from "styled-components";

export const InterfaceWidgetIconWithInfo = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: min-content auto;
    align-items: center;
    column-gap: 0.5rem;
`;
